import { NgModule } from '@angular/core';

// Directives
import { DisallowSpacesDirective } from '@src/app/shared/directives/disallowSpaces.directive';
import { HistoryBackDirective } from '@src/app/shared/directives/historyBack.directive';
import { StripTestIdDirective } from '@src/app/shared/directives/stripTestId.directive';

@NgModule({
  imports: [],
  declarations: [
    DisallowSpacesDirective,
    HistoryBackDirective,
    StripTestIdDirective
  ],
  exports: [
    DisallowSpacesDirective,
    HistoryBackDirective,
    StripTestIdDirective
  ]
})
export class DirectivesModule { }
